// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","expanded":"Footer_expanded__PLAEn","footerContent":"Footer_footerContent__aHfIE","mobile":"Footer_mobile___xq2p"};